import { render } from "./ReleaseNoteList.vue?vue&type=template&id=2646fffc"
import script from "./ReleaseNoteList.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__